import React from 'react';
import config from 'config';
import { constants, getSpecificClientConfig } from 'redux/modules/client-config/selectors';
import { useSelector } from 'react-redux';
import { Button, Flexer } from '@ontruck/orc';
import styled from 'styled-components';
import { pushWithQuery as push } from 'utils/routing';
import { injectIntl } from 'react-intl';

const ButtonStyled = styled(Button)`
  color: var(--white);
  border-color: var(--white);
  &:hover {
    border-color: var(--white);
    background-color: var(--primary-top-bar);
  }
`;

export const NewCarrierButton = injectIntl(({ intl }) => {
  const t = intl.messages.components.CarrierHome;
  const carriersCreationEnabled =
    useSelector((state) => getSpecificClientConfig(state, constants.CARRIERS_CREATION_ENABLED)) ===
    true;

  if (!carriersCreationEnabled) return <></>;
  return (
    <Flexer.Child mRight="S">
      <ButtonStyled
        ghost
        skin="primary"
        text={t.new_carrier.new_carrier}
        onClick={() => {
          push({ pathname: `${config.BASE_ROUTE}carrier/new/` });
        }}
      />
    </Flexer.Child>
  );
});
